import { Component, ViewChild } from '@angular/core';
import { DxValidationGroupComponent } from 'devextreme-angular';
import { BaseEntity, BaseState, LoginParams, BaseResponse } from '@base/entities/BaseEntities';
import { BasePageComponent } from '@base/component/BasePageComponent';
import { ServiceBagService, ServiceBagServices } from '@base/component/ServiceBag';
import { SysGlobals } from '@core/framework/sysglobals';
import { RC } from '@core/framework/resources.service';
import { LoginEndpoint } from '@core/endpoints/login.endpoint';

class State extends BaseState {
    OldPassword: string
    NewPassword1: string
    NewPassword2: string
}
@Component({
    providers: ServiceBagServices,
    selector: 'm4u-passwordchange',
    templateUrl: './passwordchange.component.html',
    styleUrls: ['./passwordchange.component.scss']
})
export class PasswordChangeComponent extends BasePageComponent<BaseEntity, State>
{
    @ViewChild('validationGroup') protected validationGroup: DxValidationGroupComponent;

    constructor(A: ServiceBagService, private loginEndpoint: LoginEndpoint) {
        super(A, 'ChangePasswordComponent', LoginParams, State);
        this.BindHandler('IsPasswordsMatch');
        this.BindHandler('IsPasswordComplex');
    }


    //Make the change. 
    //After making the change, logout and show the login screen
    //Also, reset the stored password
    //This procedure is done since the session has expired on the server because of the change, and we need a new one
    OnSubmit() {
        if (!this.validationGroup.instance.validate().isValid) return;
        var params = new LoginParams;
        params.SecureKey = this.State.OldPassword;
        params.NewPassword = this.State.NewPassword1;
        this.Do(this.loginEndpoint.ChangePassword(params), false, () => {
            this.UI.InfoMessage(RC("titlePasswordChanged"));
            // this.A.Session.LogoutAndResetSession();
            this.A.Session.EndSession(() => { this.Navigate(['/system/login'], { Language: SysGlobals.Language }); });
        });
    }

    OnCancel() {
        this.A.Framework.NavigateDefault();
    }

    IsPasswordsMatch(): boolean {
        return this.State.NewPassword1 == this.State.NewPassword2;
    }

    //Verifies (server-side) whether password is complex enough
    IsPasswordComplex() {
        return new Promise((resolve, reject) => {
            var params = new LoginParams;
            params.SecureKey = this.State.NewPassword1;
            params.Language = SysGlobals.Language;
            this.Do(this.loginEndpoint.VerifyPasswordComplexity(params), false, () => resolve(true), (response: BaseResponse) => reject(response.ResponseMessage));
        });
    }
}
